// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/assets/';

export const apiUrl = 'https://mansthal.com/apibackend/apis/';
export const assetsUrl = 'https://mansthal.com/apibackend/storage/app/public/uploads/';

// export const apiUrl = 'http://192.168.1.204:8000/apis/';
// export const assetsUrl = 'http://192.168.1.204:8000/assets/';